// Source: app/scripts/controllers/auction-report.js
Auction.controller('AuctionReportController', [
    '$scope',
    '$filter',
    '$routeParams',
    '$location',
    'toaster',
    'Auction',
    'crudService',
    function ($scope, $filter, $routeParams, $location, toaster, Auction, crudService) {

        $scope.auctionId = $routeParams.auctionId;
        Auction.get({
            id: $scope.auctionId
        }, function (data) {
            $scope.entity = data;
            $scope.auctionLog = Auction.getLog({
                code: $scope.entity.auctionNumber
            });

            Auction.getRequests({
                id: $scope.entity.id
            }, function (data) {
                $scope.requests = data;
            });
            Auction.getOutcome({
                id: $scope.entity.id
            }, function (data) {
                $scope.outcome = data;
            });
        });


//        var service = crudService('auction', {
//            republish: {
//                method: 'POST',
//                url: '/data/rest/auctions/republish'
//            }
//        });
//
//        $scope.republish = function () {
//            service.republish($scope.entity, function () {
//                toaster.pop('success', $filter('translate')('generic.success'),
//                        $filter('translate')("eauction.republish_success"));
//                $location.path("/");
//            });
//        };

    }]);
